import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseContractSignedTemplates = [
  {
    id: '-210001',
    language: Language.EN,
    subject: 'Lease contract signed',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_CONTRACT_SIGNED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Dear tenant,</p>
          <p>Your lease contract has been signed by all stakeholders.</p>
          <p>Please find all signed documents here: {{pdfLink}}.</p>
          <p>Kind regards.</p>
      `,
  },
  {
    id: '-210002',
    language: Language.FR,
    subject: 'Contrat de bail signé',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_CONTRACT_SIGNED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Cher/Chère locataire,</p>
          <p>Votre contrat de bail a été signé par toutes les parties.</p>
          <p>Vous trouverez les documents signés ici: {{pdfLink}}.</p>
          <p>Bien à vous.</p>
      `,
  },
  {
    id: '-210003',
    language: Language.NL,
    subject: 'Huurcontract ondertekend',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_CONTRACT_SIGNED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Beste huurder,</p>
          <p>Uw huurcontract werd door alle partijen ondertekend.</p>
          <p>Alle ondertekende documenten vindt u hier: {{pdfLink}}.</p>
          <p>Groeten.</p>
      `,
  },
  {
    id: '-210004',
    language: Language.DE,
    subject: 'Mietvertrag unterzeichnet',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_CONTRACT_SIGNED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Sehr geehrte/r Mieter/in,</p>
          <p>Ihr Mietvertrag wurde von allen Beteiligten unterzeichnet.</p>
          <p>Alle unterzeichneten Dokumente finden Sie hier: {{pdfLink}}.</p>
          <p>Mit freundlichen Grüßen.</p>
      `,
  },
];
